import React, { useEffect, useRef } from 'react';

/**
 * Sign-out landing page. Okta has already destroyed its session and
 * redirected here via postLogoutRedirectUri.
 *
 * Flow: Redirect to idmmaster logged out page
 *
 */
const SignOut: React.FC = () => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    // Redirect to idmmaster logged out page
    const sloUrl = process.env.REACT_APP_SIGN_OUT_URL;
    const redirectUrl = `${sloUrl}`;
    window.location.replace(redirectUrl);
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
      Signing out...
    </div>
  );
};

export default SignOut;
